var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWay2News(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFB327"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35608 6.34546H16.644V11.9278H7.35608V6.34546ZM7.35608 13.4196H16.644V14.334H7.35608V13.4196ZM7.35608 15.0558H14.5746V15.9702H7.35608V15.0558ZM7.35608 16.7402H12.8422V17.6545H7.35608V16.7402Z",
    fill: "#F3F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWay2News);
export default __webpack_public_path__ + "static/media/way2news.cbacbeddcd72c214c95aa37a4d64e9df.svg";
export { ForwardRef as ReactComponent };